import AssetsServiceManagement from '../AssetsServiceManagement';
import {
  APPLY_FILTERS,
  SET_ITEMS,
  SET_ASSET_DETAIL
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },
  async getAssetsList({ commit, state }) {
    const { items, total } = await AssetsServiceManagement.getAssetsList(state.filters);

    commit(SET_ITEMS, { items, total });
  },
  async getAssetDetails({ commit }, id) {
    const result = await AssetsServiceManagement.getAssetDetails(id);
    commit(SET_ASSET_DETAIL, result);
  },
  async updateAsset({ commit }, { id, data }) {
    const result = await AssetsServiceManagement.updateAsset(id, data);
    commit(SET_ASSET_DETAIL, result);
  },
};
